import { ChangeDetectorRef, Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { CookieService } from 'ngx-cookie-service';
import { FormDataService } from 'src/app/service/form-data.service';
import { LoadingService } from 'src/app/service/loading.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormLoginService } from 'src/app/service/form-login.service';

@Component({
  selector: 'app-login-new',
  templateUrl: './login-new.component.html',
  styleUrls: ['./login-new.component.scss']
})
export class LoginNewComponent extends FieldWrapper {

  errorMessage!: SafeHtml;
  hasError: boolean = false;
  modalOpen: boolean = false;
  email!: string;
  password: string = '';
  confirmPassword: string = '';
  passwordErrorMessage: string = '';
  isCreateDisabled: boolean = true;

  constructor(
    private formDataService: FormDataService,
    private formLoginService: FormLoginService,
    private loadingService: LoadingService,
    private cookieService: CookieService,
    private changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {
    super();
  }

  onRegister(): void {
    if (!this.formControl.valid) {
      this.setErrorMessage("A valid email address is required");
      return;
    }

    const { email } = this.model;
    
    this.loadingService.setLoading(true);

    this.formDataService.checkEmailExists(email).subscribe({
      next: (res: any) => {
        this.loadingService.setLoading(false);
        res.valid ? this.openModal(email) : this.showEmailError();
      },
      error: () => {
        this.loadingService.setLoading(false);
        this.setErrorMessage("An error occurred while checking the email.");
      },
    });
  }

  onSubmit(): void {
    if (this.isCreateDisabled) return;

    this.loadingService.setLoading(true);

    this.formDataService.createProspectProfile(this.email, this.password).subscribe({
      next: (res: any) => {
        res === 'Created' ? this.loginUser() : this.setErrorMessage('Unexpected response during profile creation.');
      },
      error: (err) => this.setErrorMessage(err.error.message),
    });
  }

  private loginUser(): void {
    this.formLoginService.loginUser(this.email, this.password).subscribe({
      next: (res: any) => {
        const token = res.token || res.headers?.['X-MC-Id'];
        token ? this.saveTokenAndReload(token) : this.loadingService.setLoading(false);
      },
      error: (err) => this.setErrorMessage(err.error.message),
    });
  }

  onPasswordChange(event: Event): void {
    this.password = (event.target as HTMLInputElement).value;
    this.validatePasswords();
  }

  onConfirmPasswordChange(event: Event): void {
    this.confirmPassword = (event.target as HTMLInputElement).value;
    this.validatePasswords();
  }

  private validatePasswords(): void {
    if (!this.confirmPassword) {
      this.updatePasswordState('', true);
    } else if (this.password !== this.confirmPassword) {
      this.updatePasswordState('Passwords do not match.', true);
    } else {
      this.updatePasswordState('', false);
    }
  }

  private setErrorMessage(message: string | SafeHtml): void {
    this.hasError = true;
    this.errorMessage = message;
    this.changeDetectorRef.detectChanges();
  }

  private openModal(email: string): void {
    this.email = email;
    this.hasError = false;
    this.modalOpen = true;
    this.changeDetectorRef.detectChanges();
  }

  private showEmailError(): void {
    const message = this.sanitizer.bypassSecurityTrustHtml(
      `The email address that you have entered is already in use. Have you <a href="/index.php?option=com_mclogin&view=mcforgotpassword" title="forgot username">forgotten your password</a>?`
    );
    this.setErrorMessage(message);
  }

  private saveTokenAndReload(token: string): void {
    this.cookieService.set('mcid_token', token);
    window.location.reload();
  }

  private updatePasswordState(message: string, isDisabled: boolean): void {
    this.passwordErrorMessage = message;
    this.isCreateDisabled = isDisabled;
    this.changeDetectorRef.detectChanges();
  }

  onClose(): void {
    this.modalOpen = false;
    this.changeDetectorRef.detectChanges();
  }
}
